import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

let dev = '/tsg-admin';
let dev1 = '/txpy-web';

const apis = {
    art(data) {//根据稿件统计
        return request({
            url: dev + "/sys/statistics/art",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    // foundation(data) {//根据营业额统计
    //     return request({
    //         url: dev + "/sys/statistics/foundation",
    //         method: 'post',
    //         params: data,
    //         jsonString: true,
    //     }).then((resault) => {
    //         return Promise.resolve(resault.data)
    //     })
    // },
    foundation(data) {//根据营业额统计
        return request({
            url: dev + "/sys/statistics/foundation",
            method: 'post',
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    duplicate(data) {//查重检测统计
        return request({
            url: dev + "/sys/statistics/duplicate",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    getYearListDesc(data) {//根据期刊得到年列表
        return request({
            url: dev + "/sys/statistics/getYearListDesc",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    // expertAudit(data) {//外审意见
    // 	return request({
    // 		url: dev + '/sys/expertAudit/expertAudit',
    // 		method: 'post',
    // 		data:data
    // 	}).then((resault) => {
    // 		return Promise.resolve(resault.data)
    // 	})
    // },

    periodLists(data) {//查询某年的期刊列表
        return request({
            url: dev + "/sys/statistics/periodList",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })

    },


    order(data) {//根据营业额统计
        return request({
            url: dev + "/sys/statistics/order",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    queryArticleByPeriod(data) {//每期稿件数量统计
        return request({
            url: dev + "/sys/statistics/queryArticleByPeriod",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    queryOutPeriodProgress(data) {//出刊进度统计
        return request({
            url: dev + "/sys/statistics/queryOutPeriodProgress",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    resource(data) {//稿件来源统计
        return request({
            url: dev + "/sys/statistics/resource",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },

    // 3.0.6
    getSelect(data) {//获取时间下拉
        return request({
            url: dev + "/sys/statistics/getSelect",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    artData(data) {//稿件数据统计
        return request({
            url: dev + "/sys/statistics/artData",
            method: 'post',
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    orderData(data) {//营业数据统计
        return request({
            url: dev + "/sys/statistics/orderData",
            method: 'post',
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    authorData(data) {//作者数据统计
        return request({
            url: dev + "/sys/statistics/authorData",
            method: 'post',
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    publishData(data) {//出版进度统计
        return request({
            url: dev + "/sys/statistics/publishData",
            method: 'get',
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data)
        })
    },
    
}
export default apis








// WEBPACK FOOTER //
// ./src/core/api/echarts.serve.js